import axiosInstance from '../../../api/AxiosInstance';
import { endpoints } from '../../../services/endpoints';
import { deleteProductRequest, deleteProductRequestError, deleteProductRequestSuccess } from '../../slices/Product/DeleteProductSlice';

export const DeleteProductAPI = (id) => {

    const url = `${endpoints.deleteProduct}/${id}`;
    return async (dispatch) => {
        try {
            dispatch(deleteProductRequest());
            // Returning the promise so we can await it in handleSubmit
            const response = await axiosInstance({
                method: "DELETE",
                url: url,
            })
            return dispatch(deleteProductRequestSuccess(response?.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(deleteProductRequestError(_error));
        }
    };
};
